import { useTranslation } from 'react-i18next';
import './Footer.css';

export const Footer: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <footer className="footer">
      <div className="footer-content">
        <span className="privacy-statement">{t('footer.privacy', 'Your data never leaves your browser. All generation is done locally.')}</span>
        <div className="footer-right">
          <span className="version-label">v2.5</span>
        </div>
      </div>
    </footer>
  );
};
